export default "__VITE_PUBLIC_ASSET__15e52c1f__"